import { render, staticRenderFns } from "./MemberListLikeLayout.vue?vue&type=template&id=0c9a84f1&scoped=true&"
import script from "./MemberListLikeLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListLikeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a84f1",
  null
  
)

export default component.exports